export default value => ([
  { text: 'Всі', value: null, checked: !value },
  { text: 'Поповнення', value: 'payin', checked: value === 'payin' },
  { text: 'Нарахування', value: 'payoff', checked: value === 'payoff' },
  { text: 'Виведення', value: 'payout', checked: value === 'payout' },
  { text: 'Придбання', value: 'purchase', checked: value === 'purchase' },
]);
